document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.como-blog-swiper').forEach(function (container) {
    var scrollBox = container.querySelector('.como-blog-swiper-scrollBox');
    var progressContainer = container.querySelector('.progress-container');
    var thumb = container.querySelector('.custom-thumb.progress-bar');
    var leftBtn = container.querySelector('.carousel-arrows .left-btn');
    var rightBtn = container.querySelector('.carousel-arrows .right-btn');
    
    console.log('Elements found:', {
      scrollBox: !!scrollBox,
      progressContainer: !!progressContainer,
      thumb: !!thumb,
      leftBtn: !!leftBtn,
      rightBtn: !!rightBtn
    });
    
    if (!scrollBox || !thumb || !progressContainer) return;

    function updateThumb() {
      var maxScroll = scrollBox.scrollWidth - scrollBox.clientWidth;
      if (maxScroll <= 0) {
        thumb.style.width = '100%';
        thumb.style.left = '0';
        return;
      }
      var percent = scrollBox.scrollLeft / maxScroll;
      var thumbWidth = (scrollBox.clientWidth / scrollBox.scrollWidth) * 100;
      thumb.style.width = thumbWidth + '%';
      thumb.style.left = percent * (100 - thumbWidth) + '%';
    }

    // 滚动条点击事件
    progressContainer.addEventListener('click', function(e) {
      var rect = progressContainer.getBoundingClientRect();
      var clickX = e.clientX - rect.left;
      var progressWidth = rect.width;
      var percent = clickX / progressWidth;
      
      // 计算可滚动的最大距离
      var maxScroll = scrollBox.scrollWidth - scrollBox.clientWidth;
      var targetScrollLeft = percent * maxScroll;
      
      scrollBox.scrollTo({
        left: targetScrollLeft,
        behavior: 'smooth'
      });
    });

    // 左右按钮点击事件
    if (leftBtn) {
      leftBtn.addEventListener('click', function(e) {
        e.preventDefault();
        console.log('Left button clicked');
        var cards = scrollBox.querySelectorAll('.card');
        if (cards.length > 0) {
          var cardWidth = cards[0].offsetWidth;
          var gap = 24; // CSS中设置的gap
          var scrollAmount = cardWidth + gap;
          console.log('Scrolling left by:', scrollAmount);
          scrollBox.scrollBy({
            left: -scrollAmount,
            behavior: 'smooth'
          });
        }
      });
    }

    if (rightBtn) {
      rightBtn.addEventListener('click', function(e) {
        e.preventDefault();
        console.log('Right button clicked');
        var cards = scrollBox.querySelectorAll('.card');
        if (cards.length > 0) {
          var cardWidth = cards[0].offsetWidth;
          var gap = 24; // CSS中设置的gap
          var scrollAmount = cardWidth + gap;
          console.log('Scrolling right by:', scrollAmount);
          scrollBox.scrollBy({
            left: scrollAmount,
            behavior: 'smooth'
          });
        }
      });
    }

    scrollBox.addEventListener('scroll', updateThumb);
    window.addEventListener('resize', updateThumb);
    setTimeout(updateThumb, 100);
  });
}); 